// Action Types
export const FETCH_POD_DATA = 'FETCH_POD_DATA';
export const FETCH_POD_DATA_LOADING = 'FETCH_POD_DATA_LOADING';
export const FETCH_POD_DATA_ERROR = 'FETCH_POD_DATA_ERROR';

export const FETCH_MASTER_DATA = 'FETCH_MASTER_DATA';
export const FETCH_MASTER_DATA_LOADING = 'FETCH_MASTER_DATA_LOADING';
export const FETCH_MASTER_DATA_ERROR = 'FETCH_MASTER_DATA_ERROR';

export const SET_FILTERS = 'SET_FILTERS';
export const SET_GROUP_BY = 'SET_GROUP_BY';
export const SET_CURRENT_TAB = 'SET_CURRENT_TAB';
export const SET_SELECTED_ROWS = 'SET_SELECTED_ROWS';
export const SET_PAGINATION = 'SET_PAGINATION';

export const APPROVE_PODS = 'APPROVE_PODS';
export const APPROVE_PODS_LOADING = 'APPROVE_PODS_LOADING';
export const APPROVE_PODS_ERROR = 'APPROVE_PODS_ERROR';

export const REJECT_PODS = 'REJECT_PODS';
export const REJECT_PODS_LOADING = 'REJECT_PODS_LOADING';
export const REJECT_PODS_ERROR = 'REJECT_PODS_ERROR';

export const FETCH_VENDOR_OPTIONS = 'FETCH_VENDOR_OPTIONS';
export const FETCH_VENDOR_OPTIONS_LOADING = 'FETCH_VENDOR_OPTIONS_LOADING';
export const FETCH_VENDOR_OPTIONS_ERROR = 'FETCH_VENDOR_OPTIONS_ERROR';

export const FETCH_HUB_OPTIONS = 'FETCH_HUB_OPTIONS';
export const FETCH_HUB_OPTIONS_LOADING = 'FETCH_HUB_OPTIONS_LOADING';
export const FETCH_HUB_OPTIONS_ERROR = 'FETCH_HUB_OPTIONS_ERROR';

export const DOWNLOAD_PODS = 'DOWNLOAD_PODS';
export const DOWNLOAD_PODS_LOADING = 'DOWNLOAD_PODS_LOADING';
export const DOWNLOAD_PODS_ERROR = 'DOWNLOAD_PODS_ERROR';

// Default Values
export const DEFAULT_PAGE_SIZE = 100;
export const PAGE_SIZE_OPTIONS = [50, 100, 150];
export const DEBOUNCE_DELAY = 500;
export const MIN_SEARCH_LENGTH = 3;
export const MIN_GENERAL_SEARCH_LENGTH = 3;

// AI Suggestion Types
export const AI_SUGGESTIONS = {
  APPROVE: 'APPROVE',
  REVIEW: 'REVIEW',
  REJECT: 'REJECT',
  NOT_AVAILABLE: 'NOT_AVAILABLE'
} as const;

// AI Suggestion Sort Order (APPROVE > REVIEW > REJECT > NOT_AVAILABLE)
export const AI_SUGGESTION_ORDER = {
  APPROVE: 1,
  REVIEW: 2,
  REJECT: 3,
  NOT_AVAILABLE: 4
} as const;

// POD Status Types
export const POD_STATUS = {
  PENDING: 'pending',
  APPROVED: 'approved',
  REJECTED: 'rejected'
} as const;

// Group By Options
export const GROUP_BY_OPTIONS = {
  AI_SUGGEST: 'AI-SUGGEST',
  VENDOR: 'VENDOR'
} as const;

// API Endpoints
export const API_ENDPOINTS = {
  MASTER_DATA: '/CRMDashboard/pod-approval/masterdata',
  FETCH_PODS: '/CRMDashboard/pod-approval/fetch',
  DOWNLOAD_PODS: '/CRMDashboard/pod-approval/download',
  APPROVE_PODS: '/CRMDashboard/request/approve',
  REJECT_PODS: '/CRMDashboard/request/reject',
  AI_ANALYSIS: '/Dashboard/dia/analysis/result',
  VENDOR_SEARCH: '/Dashboard/vehiclevendor/get',
  HUB_SEARCH: '/Dashboard/consignments/searchEmployeeHubs'
} as const;

// Table Column Keys
export const TABLE_COLUMNS = {
  CONSIGNMENT_NUMBER: 'consignmentNumber',
  TRIP_NUMBER: 'tripNumber',
  VENDOR_NAME: 'vendorName',
  HUB_CODE: 'hubCode',
  AI_SUGGEST: 'aiSuggestion',
  ACTIONS: 'actions'
} as const;

// Color Schemes for AI Suggestions
export const AI_SUGGESTION_COLORS = {
  APPROVE: {
    background: '#FFFFFF',
    border: '#148A27',
    color: '#148A27',
    iconColor: '#148A27'
  },
  REVIEW: {
    background: '#FFFFFF',
    border: '#F0A105',
    color: '#F0A105',
    iconColor: '#F0A105'
  },
  REJECT: {
    background: '#FFFFFF',
    border: '#D61F1F',
    color: '#D61F1F',
    iconColor: '#D61F1F'
  },
  NOT_AVAILABLE: {
    background: '#FFFFFF',
    border: '#8C8C8C',
    color: '#8C8C8C',
    iconColor: '#8C8C8C'
  }
} as const;
